import { observer } from 'mobx-react-lite'
import { Form, Input, Segment } from 'semantic-ui-react'
import { useStore } from '../../app/stores/store'

const ReelSmarttrackerComponents = () => {
    const { TrackingReportStore } = useStore();
  return (
    <Segment>
    <div className="smartrackerinputs">
    <div style={{ display: 'flex', gap: '15px', justifyContent: 'center' }}>
      <Form.Field
        required={true}
        control={Input}
        value={TrackingReportStore.reelSmarttrackerComponent.input_Path}
        placeholder={'Please enter an input path'}
        label={'Input Path'}
        disabled={false}
        onChange={(e: any, data: any) => TrackingReportStore.reelSmarttrackerComponent.input_Path = data.value}
      />
      <Form.Field
        required={true}
        control={Input}
        value={TrackingReportStore.reelSmarttrackerComponent.output_Path}
        placeholder={'Please enter an output path'}
        label={'Output Path'}
        disabled={false}
        onChange={(e: any, data: any) => TrackingReportStore.reelSmarttrackerComponent.output_Path = data.value}
      />
    </div>
  </div>
  </Segment>
  )
}

export default observer(ReelSmarttrackerComponents)